export default [
    {
        name: 'cadastro-plano-funerario',
        path: 'plano-funerario',
        redirect: 'plano-funerario/index',
        component: () => import(/* webpackChunkName: 'cadastro-plano-funerario' */ '@/views/cadastro/plano-funerario/Index'),
        children: [
            {
                meta: { title: 'Lista de planos funerários' },
                name: 'cadastro-plano-funerario-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-plano-funerario' */ '@/views/cadastro/plano-funerario/List.vue'),
            },
            {
                meta: { title: 'Cadastro de plano funerário' },
                name: 'cadastro-plano-funerario-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-plano-funerario' */ '@/views/cadastro/plano-funerario/Form.vue'),
            },
            {
                meta: { title: 'Edição de plano funerário' },
                name: 'cadastro-plano-funerario-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'cadastro-plano-funerario' */ '@/views/cadastro/plano-funerario/Form.vue'),
            },
        ],
    },
]